export default __webpack_public_path__ + "static/media/howitworks-Image.029fc53c.svg";